import { call, put, takeLatest } from 'redux-saga/effects';

import { HealthQuote } from '@models/HealthQuote';
import { HealthQuoteApi } from '@apis/HealthQuoteApi';
import { history } from '@utils/history';
import { SagaPayload } from '@utils/typescript';
import { routeHealthQuotePaymentPage } from '@components/HealthQuotePaymentPage';
import { BillingApi } from '@apis/BillingApi';
import { Billing } from '@models/Billing';

import {
  healthQuoteFind,
  HealthQuoteFindPayload,
  healthQuoteCreate,
  HealthQuoteCreatePayload,
  healthQuoteFetch,
  HealthQuoteFetchPayload,
  healthQuoteUpdate,
  HealthQuoteUpdatePayload,
  healthQuoteCustom,
  HealthQuoteCustomPayload,
  healthQuotePay,
  HealthQuotePayPayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';
import { routeHealthQuoteBuyReviewPage } from './route';

function* handleHealthQuoteFind({ payload }: SagaPayload<HealthQuoteFindPayload>) {
  const state: StateUpdatePayload = { healthQuote: null };
  try {
    state.healthQuote = (yield call(HealthQuoteApi.find, payload)) as HealthQuote;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleHealthQuoteCreate({ payload }: SagaPayload<HealthQuoteCreatePayload>) {
  const state: StateUpdatePayload = { healthQuote: null };
  try {
    state.healthQuote = (yield call(HealthQuoteApi.create, payload)) as HealthQuote;
    yield put(stateUpdate(state));
    history.navigate(routeHealthQuoteBuyReviewPage({ orderNumber: state.healthQuote.orderNumber }));
  } catch { }
}

function* handleHealthQuoteFetch({ payload }: SagaPayload<HealthQuoteFetchPayload>) {
  const state: StateUpdatePayload = { healthQuote: null };
  try {
    state.healthQuote = (yield call(HealthQuoteApi.get, payload)) as HealthQuote;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleHealthQuoteUpdate({ payload }: SagaPayload<HealthQuoteUpdatePayload>) {
  const state: StateUpdatePayload = { healthQuote: null };
  try {
    state.healthQuote = (yield call(HealthQuoteApi.update, payload)) as HealthQuote;
    yield put(stateUpdate(state));
    history.navigate(routeHealthQuoteBuyReviewPage({ orderNumber: state.healthQuote.orderNumber }));
  } catch { }
}

function* handleHealthQuoteCustom({ payload }: SagaPayload<HealthQuoteCustomPayload>) {
  const state: StateUpdatePayload = { healthQuote: null };
  try {
    state.healthQuote = (yield call(HealthQuoteApi.custom, payload)) as HealthQuote;
    yield put(stateUpdate(state));
    history.navigate(routeHealthQuoteBuyReviewPage({ orderNumber: state.healthQuote.orderNumber }));
  } catch { }
}

function* handleHealthOrderPay({ payload }: SagaPayload<HealthQuotePayPayload>) {
  try {
    const { id } = (yield call(BillingApi.create, payload)) as Billing;
    history.navigate(routeHealthQuotePaymentPage({ orderNumber: payload.orderNumber, billingId: id }));
  } catch { }
}


export default function* () {
  yield takeLatest(healthQuoteFind, handleHealthQuoteFind);
  yield takeLatest(healthQuoteCreate, handleHealthQuoteCreate);
  yield takeLatest(healthQuoteFetch, handleHealthQuoteFetch);
  yield takeLatest(healthQuoteUpdate, handleHealthQuoteUpdate);
  yield takeLatest(healthQuoteCustom, handleHealthQuoteCustom);
  yield takeLatest(healthQuotePay, handleHealthOrderPay);
}
